export function Container({ children, className }) {
    return <div class={`container${className?` ${className}`:''}`}>
        <div class="inner">
            {children}
        </div>
    </div>;
}